var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-card"},[_vm._t("header"),_c('div',{staticClass:"card-content"},[(_vm.lastUpdated)?_c('div',{staticClass:"last-updated"},[_vm._v("\n      情報更新日時："+_vm._s(_vm.lastUpdated)+"\n    ")]):_vm._e(),_vm._t("content")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }